export class EmailDistributionFilterModel {
    distributionID: number;
    customerID: number;
    userID: number;
    currentPageIndex: number;
    rowsPerPage: number;
    sortOrder: string;
    searchText: string;
}

export class NewsroomFilterModel {
    storyNames: string[];
}
